import WithMutation from './WithMutation';

export default WithMutation;
